(function ($, App, Utils, Components) {
    'use strict';

    const logger = new Logger('StoreSelectionEnabled');

    Components.create('StoreSelectionEnabled', {

        Selectors: {
            storeSelect: 'select[id="storeId"]',
            submitButton: 'button[id="submit-selected-store"]'
        },

        setStoreCookieOnSubmit: () => {$(Components.StoreSelectionEnabled.Selectors.submitButton).click(() => {
        	let storeId = $(Components.StoreSelectionEnabled.Selectors.storeSelect).children('option:selected').val();
        	if(storeId) {
        		Cookies.set('storeId', storeId);
                Components.trigger(Components.PreferredStore.Events.storeSaved, {storeId: storeId});
        	}
        })},
        
        init: () => {
            Components.StoreSelectionEnabled.setStoreCookieOnSubmit();
        }

    });

})(jQuery,
    window.App,
    window.App.Utils,
    window.App.Components
);
